module.exports = __webpack_public_path__ + "img/qiyechat.b7289a96.png";